import React from 'react';
import { Alert, Container } from 'cstar-react-primitives/lib/redux-form';

import errorMessages from './errorMessages';


const NotFound = () => (
    <Container hasSlimPadding>
        <Alert
            alertType="warning"
            hasHeading={false}
            message={errorMessages.notFoundTitle}
        />
    </Container>
);

export default NotFound;
